<script setup lang="ts">
</script>
<template>
  <div class="tw-w-full tw-h-full tw-p-4 tw-flex tw-flex-col">
    <!-- Skeleton Big Card -->
    <div
      class="tw-border-4 tw-border-solid tw-border-connx-grey-tint-60 tw-rounded-lg tw-p-6 tw-my-4 tw-flex-1 tw-flex tw-flex-col tw-justify-center tw-gap-6 animate-pulse"
    >
      <div class="tw-grid tw-grid-cols-2 tw-gap-x-8 tw-items-center tw-h-full">
        <!-- Total Placeholder -->
        <div class="tw-h-20 tw-bg-connx-grey-tint-75 tw-rounded"></div>

        <!-- Badge Placeholder -->
        <div class="tw-h-12 tw-bg-connx-grey-tint-75 tw-rounded-lg"></div>
      </div>
    </div>

    <!-- Subtitle Skeleton -->
    <div class="tw-h-4 tw-w-1/2 tw-bg-connx-grey-tint-60 tw-rounded tw-mb-2 animate-pulse"></div>

    <!-- Cards Skeleton -->
    <div class="tw-grid tw-grid-cols-3 tw-gap-4">
      <div
        v-for="i in 3"
        :key="i"
        class="tw-bg-connx-grey-tint-60 tw-rounded-lg tw-p-4 tw-h-14 animate-pulse"
      ></div>
    </div>
  </div>
</template>